import React from 'react';
import { Typography } from '@crisellevaldez/speculo-ui';
import { Activity } from '../../../../types/activity.types';
import { ActivityItem } from './ActivityItem';

interface ActivityGroupProps {
  dateGroup: string;
  activities: Activity[];
  newlyAddedItems: string[];
  onSelectCall: (call: any) => void;
  onSelectEmail?: (email: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelectSms?: (sms: any) => void;
  timezone?: string;
}

export const ActivityGroup: React.FC<ActivityGroupProps> = ({
  dateGroup,
  activities,
  newlyAddedItems,
  onSelectCall,
  onSelectEmail,
  onSelectSms,
  timezone,
}) => {
  return (
    <div>
      <div className="flex items-center mb-2">
        <Typography
          variant="h6"
          className="text-muted-foreground uppercase !text-xs tracking-wider"
        >
          {dateGroup}
        </Typography>
      </div>

      <div className="space-y-2 xl:space-y-3">
        {activities.map((activity) => (
          <ActivityItem
            key={activity.id}
            activity={activity}
            isNewlyAdded={newlyAddedItems.includes(activity.id)}
            onSelectCall={onSelectCall}
            onSelectEmail={onSelectEmail}
            onSelectSms={onSelectSms}
            timezone={timezone}
          />
        ))}
      </div>
    </div>
  );
};
